import { ThemeUICSSObject } from '@apia/theme';

const connectors: ThemeUICSSObject = {
  testResult: {
    td: {
      verticalAlign: 'middle !important',

      '&.title': {
        fontWeight: 'bold',
        textAlign: 'center',
      },

      div: {
        height: '1.5em',
        width: '1.5em',
        borderRadius: '100px',
        mx: 'auto',
      },

      '&.success': {
        p: 3,
        div: { backgroundColor: 'palette.success.main' },
      },
      '&.error': {
        p: 3,
        div: { backgroundColor: 'palette.error.main' },
      },
    },
  },
};

export default connectors;
